import React from 'react'
import { useIntl } from 'react-intl'

import { LifeBuoyIcon } from 'lucide-react'

import { CountBadge } from '@/components/atoms/CountBadge'
import { cn } from '@/lib/utils.ts'

export interface SupportButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  readonly count: number
}

export const SupportButton = React.forwardRef<HTMLButtonElement, SupportButtonProps>(
  ({ count, className, ...props }, ref) => {
    const intl = useIntl()
    return (
      <button
        ref={ref}
        type="button"
        className={cn(
          'flex h-8 shrink-0 cursor-pointer items-center gap-2 rounded-[4px] border border-orange-300 bg-gray-700 px-3 text-base font-bold text-white hover:bg-gray-600 focus-visible:ring-1 focus-visible:ring-orange-300 focus-visible:outline-none',
          className
        )}
        {...props}>
        <LifeBuoyIcon aria-hidden className="size-4 text-orange-300" />
        <span>{intl.formatMessage({ id: 'soutien.button' })}</span>
        <CountBadge count={count} aria-label={intl.formatMessage({ id: 'soutien.button.unread' }, { count })} />
      </button>
    )
  }
)
